export default __webpack_public_path__ + "static/media/Close.cdacdba2.svg";